import { privateHttp } from "~/config/axios";
import type { BaseApiResponse } from "~/types/common";
import { isMungApp, openExternalBrowser } from "%/externalBrowser";

interface HandoffIssueResponse {
  token: string;
  redirectUrl: string;
  expiresInSeconds: number;
}

const unwrap = <T,>(payload: BaseApiResponse<T> | T | undefined): T => {
  if (payload == null) throw new Error("응답이 비어있습니다");
  if (typeof payload === "object" && payload !== null && "data" in (payload as any)) {
    return (payload as BaseApiResponse<T>).data;
  }
  return payload as T;
};

const buildCurrentOriginHandoffUrl = (
  issued: HandoffIssueResponse,
  redirectPath: string,
): string => {
  if (!issued.token) {
    return issued.redirectUrl;
  }

  const url = new URL("/auth/handoff", window.location.origin);
  url.searchParams.set("token", issued.token);
  url.searchParams.set("path", redirectPath);
  url.searchParams.set("fromApp", "1");
  return url.toString();
};

export const openWithHandoffIfApp = async (
  redirectPath: string,
  fallbackNavigate: () => void,
): Promise<void> => {
  if (!isMungApp()) {
    fallbackNavigate();
    return;
  }

  try {
    const { data } = await privateHttp.post<BaseApiResponse<HandoffIssueResponse>>(
      "/auth/handoff/issue",
      { redirectPath, fromApp: true },
    );
    const issued = unwrap(data);

    const redirectUrl = buildCurrentOriginHandoffUrl(issued, redirectPath);
    if (!redirectUrl) {
      throw new Error("핸드오프 URL이 비어있습니다");
    }

    openExternalBrowser(redirectUrl);
  } catch (e) {
    console.error("[handoff] issue failed:", e);
    fallbackNavigate();
  }
};
